import React from 'react';

import { Group, Paper, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import GoBackButton from 'components/BackButton/GoBackButton';

import useStyles from './useStyles';

const HeaderWithoutExpectations = (): JSX.Element => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`, false);
  const { classes } = useStyles();

  return (
    <Paper className={classes.baseHeader}>
      <Group noWrap spacing='xl' data-cy='packageUtilizationPageHeader'>
        <GoBackButton />
        <Title order={isDesktop ? 1 : 3}>Package Utilization</Title>
      </Group>
    </Paper>
  );
};

export default HeaderWithoutExpectations;
